import React from 'react';
import { IdentityBrokerError, IdentityBrokerErrorType } from '../../components/error-pages/identity-broker-error';
import { getUrlSearchParams } from '../../utils';

export const IdentityBrokerErrorPage: React.FC = () => {
    const errorType = getUrlSearchParams().get('errorType') as IdentityBrokerErrorType;
    return <IdentityBrokerError type={errorType || IdentityBrokerErrorType.GENERAL_ERR} />;
};
